<template>
  <div>
    <div class="m-edition-section-content-subject m-edition-map-messages">
      <blockquote
        v-if="!$store.getters.getAssetNodes.length"
        class="quote quote-maps-primary quote-first"
      >
        <p>
          <span>
            {{ $t('mEditionMapMessages.quote.firstText') }}
            {{ $t('mEditionMapMessages.quote.secondText') }}
            <router-link
              :to="`/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.path.subject')}`"
              class="text-color-maps-primary"
            >
              {{ $t('mEditionMenu.map.path.text') }}.
            </router-link>
          </span>
        </p>
      </blockquote>

      <div
        v-if="$store.getters.getAssetNodes.length"
        class="m-edition-section-content-subject-split-edition"
      >
        <div class="m-edition-section-content-subject-split-edition-item-left">
          <MoleculeEditionMapMessagesList/>
        </div>
        <div class="m-edition-section-content-subject-split-edition-item-right">
          <MoleculeEditionMapMessagesRecord/>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapMessages',

  components: {
    MoleculeEditionMapMessagesList: () => import('@/components/molecules/MoleculeEditionMapMessagesList'),
    MoleculeEditionMapMessagesRecord: () => import('@/components/molecules/MoleculeEditionMapMessagesRecord')
  },

  props: {
    element: Object,
    elementCategorias: Array
  }
}
</script>
